import { JOURNEY_ARCHETYPE } from "@shared/constants";

export function getDealMyFilesConfig(deal, appConfig) {
  const { businessModel, financeSimulation: { journey } = {} } = deal;
  const refinedJourney =
    journey === JOURNEY_ARCHETYPE.CASH
      ? JOURNEY_ARCHETYPE.CASH
      : JOURNEY_ARCHETYPE.FINANCE;

  const defaultConfig = {
    enabled: false,
    registrationRegionSelect: false,
    bulkSubmit: false,
  };

  const source = deal.configuration ?? appConfig;

  const config = source.app.myFiles?.[businessModel]?.[refinedJourney];

  // TODO: extend with key account

  return config || defaultConfig;
}
